import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73c8fa1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-4" }
const _hoisted_2 = { class: "flex items-center gap-1" }
const _hoisted_3 = { class: "gordita-400-13 text-Text/text_medium" }
const _hoisted_4 = { class: "flex gap-1.5 items-center" }
const _hoisted_5 = ["data-testid", "data-value"]


import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { formatNumber } from '@/services/utils';
import { IncrediChartBar } from 'incredi-ui';

type Section = {
  title: string;
  value: number;
  color: string;
  dataTestId: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'workload-view-performance-bar-chart',
  props: {
    chartId: null,
    sections: null
  },
  setup(__props: any) {

const props = __props as {
  chartId: string;
  sections: Section[];
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "workload-view-performance-bar-chart flex flex-row gap-8 w-full" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IncrediChartBar), {
        style: {"width":"80px","height":"120px"},
        height: "120px",
        class: "bar-chart",
        "chart-id": __props.chartId,
        labels: [],
        options: {
        barWidth: 32,
        width: 42,
        height: 120,
        legend: {
          show: false,
        },
        toolbox: {
          show: false,
        },
        grid: {
          containLabel: false,
          left: 16,
          right: 100,
          top: 1,
          bottom: 0,
        },
        cursor: 'default',
        xAxis: {
          boundaryGap: false,
          data: __props.sections.map(section => section.title),
          show: false,
        },
        yAxis: {
          show: false,
        },
        dataZoom: [
          {
            show: false,
          },
          {
            show: false,
          },
        ],
      },
        series: [
        {
          type: 'bar',
          data: __props.sections.map(({ value, color }) => ({ value, itemStyle: { color } })),
          barGap: '100px',
        },
      ]
      }, null, 8, ["chart-id", "options", "series"]),
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.sections, (section) => {
          return (_openBlock(), _createElementBlock("div", {
            key: section.title,
            class: "flex flex-col items-start gap-1"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "w-2 h-2 rounded-full",
                style: _normalizeStyle({ backgroundColor: section.color })
              }, null, 4),
              _createElementVNode("div", _hoisted_3, _toDisplayString(section.title), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", {
                class: "percent gordita-medium-500-20",
                "data-testid": section.dataTestId,
                "data-value": section.value
              }, _toDisplayString(_unref(formatNumber)(section.value)), 9, _hoisted_5)
            ])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})